import { React, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import db from "../../../api/mongodb";
import {
  Container,
  Row,
  Col,
  Image,
  Button,
  Form,
  InputGroup,
} from "react-bootstrap";
import { defaultOptions1 } from "../../../config/loading-config.js";
import Lottie from "react-lottie";
import SearchIcon from "../../../images/Search.svg";

// import "./ClientsGridView.scss";
import "./Test.scss";
import ClientsGridList from "./ClientsGridList";
// import CreateClient from "../components/layout/clients/CreateClient";
import Pagination from "../../../utils/helpers/components/Pagination";
import { UserContext } from "../../../api/UserProvider";
import { useQuery } from "@tanstack/react-query";

const ClientsGridView = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [filteredList, setFilteredList] = new useState(clients);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsCount, setItemsCount] = useState(0);
  const itemsPerPage = 6;
  const userId = useContext(UserContext).id;
  const [search, setSearch] = useState("");

  const clientQuery = useQuery({
    queryKey: ["clients", currentPage, itemsPerPage, search],
    queryFn: async () => {
      const response = await db.get(
        `/api/clients/findBySafeApProject?page=${currentPage}&limit=${itemsPerPage}&searchField=${search}`
      );
      return response.data;
    },
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  useEffect(() => {
    if (clientQuery.status === "success") {
      setFilteredList(clientQuery.data.data);
      setItemsCount(clientQuery.data.metadata.totalCount);
    }
  }, [clientQuery.status, clientQuery.isFetching]);



  return (
    <>
      <div className="client-grid">
        <div className="client-grid-header">
          <h1 className="page-title">Clients</h1>
          <Link to="/clients/new">
            <Button className="btn-primary">Create New Client</Button>
          </Link>
        </div>

        <div className="client-grid-header">
          <div className="search-filter">
            <InputGroup>
              <Form.Label htmlFor="searchSafeAps" hidden>
                Search Clients
              </Form.Label>
              <InputGroup.Text>
                <img src={SearchIcon} alt="" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                id="input"
                placeholder="Search clients..."
                aria-describedby="searchClients"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>
          </div>
        </div>
        {clientQuery.isPending ? (
          <Lottie options={defaultOptions1} height={200} width={200} />
        ) : (
          <div className="client-list">
            <Row>
              <ClientsGridList clients={filteredList} />
            </Row>
            <Pagination
              itemsCount={itemsCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ClientsGridView;
